var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsFranchises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 88,
    viewBox: "0 0 99 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "brandsFranchiseTitle"
  }, "WB shield in stylized network") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "brandsFranchiseTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "brandsFranchiseDesc"
  }, "WB shield in stylized network")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.973.57-4.88.908c-.05.012-.089.05-.102.128l-.229.991-1.877.51c-.052.013-.065.051-.077.101l-.254 1.045-1.828.483c-.05.015-.076.05-.102.153-.152.79-.228 1.63-.228 2.47 0 7.333 3.808 13.699 9.496 17.492.076.052.152.103.203.103.05 0 .127-.051.204-.103 5.685-3.793 9.494-10.159 9.494-17.492 0-.84-.077-1.68-.229-2.47-.024-.102-.05-.138-.102-.153l-1.826-.483-.255-1.045c-.014-.05-.026-.088-.075-.1l-1.88-.51-.23-.992c-.01-.078-.049-.116-.1-.128L10.215.57a.68.68 0 0 0-.243 0zm.832 20.908V3.583c0-.051.025-.076.076-.076 3.402.23 5.585 1.655 5.585 3.717a3.46 3.46 0 0 1-.89 2.315c1.118.306 1.55 1.146 1.55 2.267 0 1.984-1.448 5.268-6.22 9.697-.02.02-.038.029-.055.029-.026 0-.046-.022-.046-.054zM8.013 16.21c-.05-1.068-.05-2.01-.05-3.156l-.052-9.14c0-.101.026-.151.128-.177.43-.103.812-.178 1.27-.229.05 0 .075.025.075.076v17.895c0 .052-.051.076-.102.025-1.396-1.604-2.335-3.564-2.97-5.702l-.964.612c-.254.178-.457.102-.61-.178-1.294-2.291-2.13-6.059-2.208-8.706 0-.128.027-.204.127-.332.33-.406.736-.814 1.118-1.17.075-.077.152-.026.152.102 0 3.258.557 6.287 1.446 8.272.076.152.153.152.253.077l.28-.177c-.533-2.37-.836-5.525-.761-9.165 0-.127.024-.179.101-.23a8.91 8.91 0 0 1 1.22-.636c.125-.05.151-.025.151.076-.077 5.296.355 8.96 1.294 11.889.01.031.03.046.05.046.026 0 .052-.027.052-.072zm4.239-5.701c1.954-1.147 2.717-2.292 2.717-3.361 0-1.018-1.17-1.859-2.717-1.96v5.321zm0 1.73v5.752c2.59-2.902 3.325-4.887 3.325-5.904 0-.713-.33-1.12-.812-1.12-.533 0-1.015.203-2.513 1.272z",
    id: "lnazdpsjla"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.301
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.062 30.769)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mjp8hz0pib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lnazdpsjla"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#mjp8hz0pib)",
    d: "M.247 25.101H19.94V.407H.247z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M49.156 14.43v9.402"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2,5",
    d: "M31.637 13.181 39 26.094"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.192 12.41a6.115 6.115 0 0 1-6.114-10.59 6.114 6.114 0 0 1 6.114 10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2,5",
    d: "M14.118 43.525 29 43.094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.227 43.525a6.113 6.113 0 1 1-12.227 0 6.113 6.113 0 1 1 12.227 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2,5",
    d: "M31.637 73.869 39 61.094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.192 74.64a6.114 6.114 0 0 1-6.114 10.59 6.115 6.115 0 0 1 6.114-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2,5",
    d: "M66.675 73.869 60 60.094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12 74.64a6.115 6.115 0 0 1 6.114 10.59 6.114 6.114 0 0 1-6.114-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2,5",
    d: "M84.195 43.525 69 43.094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.085 43.525a6.113 6.113 0 1 1 12.227 0 6.113 6.113 0 1 1-12.227 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2,5",
    d: "M66.675 13.181 60 26.094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12 12.41a6.114 6.114 0 0 1 6.114-10.59 6.115 6.115 0 0 1-6.114 10.59zM23.959 28.977l8.142 4.702M23.959 58.073l8.142-4.702M49.156 72.62v-9.402M74.354 58.073l-8.143-4.702M74.354 28.977l-8.143 4.702M68.849 43.525c0 10.876-8.817 19.693-19.693 19.693-10.876 0-19.693-8.817-19.693-19.693 0-10.876 8.817-19.693 19.693-19.693 10.876 0 19.693 8.817 19.693 19.693zM53.924 9.662a4.767 4.767 0 1 1-9.536 0 4.767 4.767 0 1 1 9.536 0zM22.214 22.465a4.768 4.768 0 1 1-4.767 8.257 4.768 4.768 0 0 1 4.767-8.257zM17.446 56.328a4.768 4.768 0 1 1 4.768 8.257 4.768 4.768 0 0 1-4.768-8.257zM44.388 77.388a4.767 4.767 0 1 1 9.535 0 4.767 4.767 0 0 1-9.535 0zM76.099 64.586a4.768 4.768 0 1 1 4.767-8.257 4.768 4.768 0 0 1-4.767 8.257zM80.866 30.722a4.768 4.768 0 1 1-4.768-8.257 4.768 4.768 0 0 1 4.768 8.257z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsFranchises);
export default __webpack_public_path__ + "static/media/brands-franchises.31c0df7cba7bc94d96409dfb2e58026d.svg";
export { ForwardRef as ReactComponent };